module.exports = __webpack_public_path__ + "media/components/src/assets/images/embellishments/points/point_01-a6e61be68c9ae954f425eddb397771f7.svg";